// extracted by mini-css-extract-plugin
export default {"Basket":"Basket_ueQRT","Basket__items":"Basket__items_CZji8"};